//WE.Flow.Html.Models.ThemeSelectModel

export class ThemeSelectModel {
    id: string = "";
}
